export default "__VITE_ASSET__C9kozc1K__"